import { createSelector } from "@reduxjs/toolkit";
import { initialState, type AnalyticsState } from "./slice";

const analyticsRootState = (state: {
  analytics?: AnalyticsState;
}): AnalyticsState => state.analytics || initialState;

export const selectAnalytics = createSelector(
  [analyticsRootState],
  (state) => state.analytics,
);
